import React from 'react'
import CustomModal from '../../baseComponents/gui/customModal/CustomModal'
import { safeHTML } from '../../../utils/safeHTML'
import CustomButton from '../../features/customButton/ui/main/CustomButton'
import { useModal } from '../../../hooks/useModal'
import { GTMGame } from '../../../constants/analytics/GTM'
import classNames from 'classnames'
import { gamesList } from '../../../constants/copyright'
import { useTranslation } from '../../../translations'

const StartGameModal = React.forwardRef(function StartGameModal(
  {
    title,
    text,
    image,
    buttonText,
    game,
    onClose,
    isBoosterTutorial,
    callbacks,
    imageAlfa,
    imageBourjois,
  },
  ref,
) {
  const { closeModal, id } = useModal()
  const { list } = gamesList
  const { t } = useTranslation()

  const close = () => {
    onClose?.()
    closeModal({ id })
  }

  const closeAndRun = () => {
    close()
    if (!isBoosterTutorial) {
      const thisGame = Object.values(list)?.find(({ game: gameState }) => gameState === game)
      thisGame && callbacks?.gameStart(thisGame.apiName)
      GTMGame(game)
    }
  }

  return (
    <CustomModal>
      <div
        className={classNames(`start-game-modal start-game-modal_${game}`, {
          'start-game-modal_buster': isBoosterTutorial,
        })}
        ref={ref}
      >
        <div
          className='start-game-modal__bg'
          onClick={close}
        />
        <div className='start-game-modal__content'>
          <div className='start-game-modal__image'>
            <img
              src={imageAlfa ?? imageBourjois ?? image}
              alt={t(title)}
            />
          </div>
          <h2 className='start-game-modal__title'>{safeHTML(t(title))}</h2>
          <p className='start-game-modal__text'>{safeHTML(t(text))}</p>
          <CustomButton
            className={'start-game-modal__button'}
            text={buttonText}
            onClick={closeAndRun}
          />
        </div>
      </div>
    </CustomModal>
  )
})
export default StartGameModal
StartGameModal.propTypes = {}
